import { useState, useEffect, useCallback } from 'react'
import { useAuth } from './useAuth.js'
import { apiFetch } from '../lib/api.js'

interface OrgMembership {
  orgId: string
  orgName: string
  orgSlug: string
  role: 'org_admin' | 'member'
}

export function useMyOrganizations() {
  const { user, session } = useAuth()
  const [memberships, setMemberships] = useState<OrgMembership[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchOrgs = useCallback(() => {
    if (!user || !session) {
      setMemberships([])
      setLoading(false)
      setError(null)
      return
    }

    setLoading(true)
    setError(null)
    apiFetch<{ data: OrgMembership[] }>('/api/public/orgs/mine')
      .then(res => {
        setMemberships(res.data)
        setError(null)
      })
      .catch((err) => {
        setMemberships([])
        setError(err instanceof Error ? err.message : 'Failed to load organizations')
      })
      .finally(() => setLoading(false))
  }, [user, session])

  useEffect(() => {
    fetchOrgs()
  }, [fetchOrgs])

  return {
    memberships,
    loading,
    error,
    isOrgAdmin: memberships.some(m => m.role === 'org_admin'),
    refetch: fetchOrgs,
  }
}
